// --------------------------------- TYPES ---------------------------------
export type ValorParametroConsulta = string | number | boolean | null | undefined;
export type ValorParametroConsultaLista = ValorParametroConsulta[];

// ------------------------------- FUNCTIONS -------------------------------
/**
 * Define um parâmetro de consulta com semântica de **sobrescrita** e lista em **CSV**.
 *
 * Não confundir com `adicionarParametroConsulta` de `@/utils/utils`, que tem
 * comportamento diferente e não é intercambiável:
 *
 * | | `adicionarParametroConsulta` | `definirParametroConsulta` |
 * | --- | --- | --- |
 * | lista | `append` repetido (`?k=a&k=b`) | join CSV (`?k=a,b`) |
 * | escrita | `append` (acumula) | `set` (sobrescreve) |
 * | string vazia | ignora | grava |
 *
 * O catálogo e o estoque-service dependem desta variante: o `set` garante que os
 * `parametrosFixos` da entidade prevaleçam sobre o que veio no endpoint.
 */
export function definirParametroConsulta(
	parametrosConsulta: URLSearchParams,
	chave: string,
	valor: ValorParametroConsulta | ValorParametroConsultaLista,
) {
	if (valor === undefined || valor === null) return;

	if (Array.isArray(valor)) {
		const valoresUnidos = valor
			.filter((item) => item !== undefined && item !== null)
			.map(String)
			.join(",");

		if (valoresUnidos) parametrosConsulta.set(chave, valoresUnidos);
		return;
	}

	parametrosConsulta.set(chave, String(valor));
}
